module.exports = __webpack_public_path__ + "static/image/help_center_traffic_realisation.svg?d109e580d220b0054934cc94338536e4";